import styles from "./main-app-menu.module.css";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";

interface ContentAdminProps {
  didClickOption: () => void;
}

export const ContentAdmin = (props: ContentAdminProps) => {
  const { home, users, orders, products, navigateTo } = usePaths();

  return (
    <div className={styles.adminContent}>
      <span className={styles.sectionTitle}>ADMIN</span>
      <MenuOption
        label="Dashboard"
        iconName="HOME"
        onClick={() => {
          navigateTo(home);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Users"
        iconName="USER"
        onClick={() => {
          navigateTo(users);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Orders"
        iconName="BAG"
        onClick={() => {
          navigateTo(orders);
          props.didClickOption();
        }}
      />
      <MenuOption
        label="Products"
        iconName="SIZE"
        onClick={() => {
          navigateTo(products);
          props.didClickOption();
        }}
      />
    </div>
  );
};
